import { useState } from 'react';
import { API } from '../../../../api/api';
import { URLS } from '../../../../api/urls';
import { DeleteConfirmationModal } from '../../../../components/DeleteConfirmationModal/DeleteConfirmationModal';
import { ALERT_TEXT } from '../../../../constants/content';
import { useAlert } from '../../../../context/Alert.context';

interface DeleteModalProps {
  open: boolean;
  onClose: () => void;
  bannerId: string;
  updateBannerAfterDelete: () => void;
}

export const DeleteModal = ({
                              open,
                              onClose,
                              bannerId,
                              updateBannerAfterDelete,
                            }: DeleteModalProps) => {
  const [loading, setLoading] = useState(false);
  const { showAlert } = useAlert();

  const onDelete = () => {
    setLoading(true);
    API.delete(`${URLS.BANNERS}/${bannerId}`)
      .then((res) => {
        updateBannerAfterDelete();
        onClose();
        showAlert({
          message: ALERT_TEXT.BANNER_DELETE_SUCCESS,
          severity: 'success',
        });
      })
      .catch((e) => showAlert({ message: e.message, severity: 'error' }))
      .finally(() => setLoading(false));
  };

  return (
    <DeleteConfirmationModal
      loading={loading}
      onClose={onClose}
      open={open}
      onDelete={onDelete}
    />
  );
};
